import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { useFirebase } from 'react-redux-firebase';

import LinkButton from '../components/LinkButton';
import { useLazyIsAdmin } from '../hooks';

export const statusBreadcrumb = {
    "in-progress": {title: "In progress", link: "/podcasts/by-status/in-progress"},
    "done": {title: "Done", link: "/podcasts/by-status/done"},
    "published": {title: "Published", link: "/podcasts/by-status/published"},
  }

const Breadcrumbs = ({items}) => {
  return (
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 d-none d-md-flex">
        {items.map((item, index) => (
            <>
              {(index < items.length - 1) ? (
                <li className="breadcrumb-item">
                  <Link to={item.link}>
                    {item.title}
                  </Link>
                </li>
                ) : (
                  <li className="breadcrumb-item active">
                    {item.title}
                  </li>
              )}
            </>
          ))}
      </ol>
    </nav>
  );
}

const SubmitButton = () => (
  <LinkButton to="/submit">Submit content</LinkButton>
)

const SideBar = ({open, onClose}) => {
  const firebase = useFirebase();
  const location = useLocation();
  const isAdmin = useLazyIsAdmin();

  const logout = () => {
    firebase.auth().signOut();
  }

  const pathActive = (path) => location.pathname.startsWith(path) ? "active" : "";

  return (
    <nav id="sidebar" className={`col-md-3 col-lg-2 ${open && "open"}`}>
      <div className="sidebar-sticky">
        <span className="sidebar-close d-md-none" onClick={onClose}>
          <i className="fas fa-times"></i>
        </span>
        <div className="sidebar-body">
          <Link className="logo" to="/">Poise</Link>
          <ul className="nav flex-column list-unstyled">
            { isAdmin && (
              <li className={`nav-item ${pathActive('/users')}`}>
                <Link className="nav-link" to="/users">
                  <i className="fas fa-user-cog"></i>
                  Customers
                </Link>
              </li>
            )}
          </ul>
          <hr/>
          <ul className="nav flex-column list-unstyled">
            <li className={`nav-item ${pathActive('/podcasts')}`}>
              <Link className="nav-link" to="/podcasts">
                <i className="fas fa-microphone"></i>
                Podcasts
              </Link>
              <ul className="list-unstyled">
                <li className={`nav-item ${pathActive('/podcasts/by-status/in-progress')}`}>
                  <Link className="nav-link" to="/podcasts/by-status/in-progress">
                    <i className="fas fa-long-arrow-alt-right"></i>
                    In progress
                  </Link>
                </li>
                <li className={`nav-item ${pathActive('/podcasts/by-status/done')}`}>
                  <Link className="nav-link" to="/podcasts/by-status/done">
                    <i className="fas fa-long-arrow-alt-right"></i>
                    Done
                  </Link>
                </li>
                <li className={`nav-item ${pathActive('/podcastcs/by-status/published')}`}>
                  <Link className="nav-link" to="/podcasts/by-status/published">
                    <i className="fas fa-long-arrow-alt-right"></i>
                    Published
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
          <div className="mt-2 pt-3 pl-3 pr-3 d-md-none">
            <Link to="/submit" className="btn btn-block btn-primary">Submit content</Link>
          </div>
          <hr/>
          <ul className="nav flex-column list-unstyled">
            <li className={`nav-item ${pathActive('/account')}`}>
              <Link className="nav-link" to="/account">
                <i className="fas fa-user-circle" />
                My account
              </Link>
            </li>
          </ul>
          <hr/>
          <ul className="nav flex-column list-unstyled">
            <li className="nav-item">
              <span className="nav-link" onClick={logout}>
                <i className="fas fa-sign-out-alt" />
                Log out
              </span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

const Page = ({title, breadcrumbs = [], action, children}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const closeMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false)
    }
  }


  return (
    <>
    <div className="container-fluid">  
      <div className="row">
        <SideBar open={isMenuOpen} onClose={closeMenu} />
      </div>
    </div>
    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-md-4" onClick={closeMenu}>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap pt-3 pb-3 mb-3">
        {
          (breadcrumbs && breadcrumbs.length > 0) ? (
            <Breadcrumbs items={breadcrumbs} />
          ) : (
            <h1 className="page-title mb-0">{title}</h1>
          )
        }
        <span onClick={() => setIsMenuOpen(true)} className="site-menu-toggle d-md-none">
          <i className="fas fa-bars"></i>
        </span>
        { action || <SubmitButton /> }
      </div>
      {children}
    </main>
    </>
  )
}

export default Page
